import { render, staticRenderFns } from "./DocumentGroupList.vue?vue&type=template&id=28aca5f4&scoped=true&"
import script from "./DocumentGroupList.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGroupList.vue?vue&type=style&index=0&id=28aca5f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aca5f4",
  null
  
)

export default component.exports